import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

export default AccessTimeRoundedIcon;
